module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hollandsnieuwe-01.e760dbda.jpg";